module.exports = __webpack_public_path__ + "static/img/Bintro1.fcef336.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/Bintro1.png
// module id = W3Dg
// module chunks = 1